import { MutationTree } from 'vuex';
import { Auth } from '@/interface/store/auth';

export const mutations: MutationTree<Auth> = {
  EMAIL_CHECK(state, payload) {
    state.isEmail = payload.isEmail;
  },
  SET_USER(state, payload) {
    state.isAuth = true;
    state.id = payload.id;
    state.fullName = payload.fullName;
    state.email = payload.email;
    state.phoneNumber = payload.phoneNumber;
    state.organization = payload.organization;
    state.lastGroupId = payload.lastGroupId;
    state.avatar = payload.fkUserAvatars;
    state.settings = payload.settings;
    state.emailSettings = payload.emailSettings;
    state.subscribedToNewsletters = payload.subscribedToNewsletters;

    // 로컬 스토리지에 user 정보 저장;
    localStorage.setItem('users', JSON.stringify(payload));

    if (process.env.NODE_ENV === 'production') {
      // @ts-ignore
      window.analytics.identify(payload.id, {
        name: payload.fullName,
        email: payload.email,
      });
    }
  },
  SET_LAST_GROUP_ID(state, payload) {
    state.lastGroupId = payload;
  },
  IS_REGISTER(state, payload) {
    state.isRegister = payload;
  },
  LOG_OUT(state) {
    state.isAuth = false;
    state.lastGroupId = null;
  },
  RESET_ALL(state) {
    state.isEmail = false;
    state.isRegister = {};
    state.isAuth = false;
    state.id = '';
    state.fullName = '';
    state.email = '';
    state.phoneNumber = '';
    state.organization = '';
    state.lastGroupId = null;
    state.avatar = null;
    state.settings = null;
    state.emailSettings = null;
    state.subscribedToNewsletters = false;
  },
};
